/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a provider successfully saves one of the profile modules under
 * `/provider-profile/details/` -- experience, cat experience, skills, or what
 * to expect. Paired with `provider-account-info-updated` and
 * `provider-payout-info-updated` to measure completion of the management hub's
 * modules.
 *
 * &nbsp;
 */
export class ProviderProfileInfoUpdated extends AnalyticsEvent {
  eventName = 'provider-profile-info-updated';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.service_offerings.provider_profile;

  constructor(eventProperties: { provider_status: string; module: string }) {
    super(eventProperties);
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a provider skips one of the optional goals questions in sign up,
 * naming the question they skipped. Every question stores an empty answer when
 * unanswered, so the table cannot tell a deliberate skip from a question never
 * reached -- this event is what separates the two. `had_answer` separates them
 * again within the skips: someone paging back through answers they already gave
 * emits a skip per question, which is not the declaration of intent that
 * declining to answer is.
 *
 * &nbsp;
 */
export class ProviderProfileGoalsQuestionSkipped extends AnalyticsEvent {
  eventName = 'provider-profile-goals-question-skipped';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.service_offerings.provider_profile;

  constructor(eventProperties: { provider_status: string; question: string; had_answer: boolean }) {
    super(eventProperties);
  }
}
